import React, { useState, useEffect } from "react";
import userphone from "src/assets/images/user-phone-icon.svg";
import useremail from "src/assets/images/user-email-icon.svg";
import usersource from "src/assets/images/user-source-icon.svg";
import usercreated from "src/assets/images/user-create-icon.svg";
import { useUserStore } from "../../../hooks/admin/user";
import { __remove, __set } from "src/store/axios_indicator";
import Helper from "src/helper/Helper";
import { useAxiosIndicatorCheck } from "src/store/hook/useAxiosIndicatorCheck";
import useReduxState from "src/hooks/useReduxState";
import System from "src/helper/system";
import { useObjCommonFilterStore } from '../../../hooks/objCommonFilter';
import AxiosIndicatorRunTimeLoader from "src/component/Global/AxiosIndicatorRunTimeLoader";
import Constants from "src/helper/Constants";

const UserDetailHeader = (props) => {
  const [__check] = useAxiosIndicatorCheck();
  const userId = props.userId;
  const userType = props.userType;

  const [isEdit, setIsEdit] = useReduxState(false, "setIsEdit");
  const { translation:t } = System;
  const [{ userDetail }, { get_user_detail }, { update_user_detail, update_user_active_status }] = useUserStore();
  const [{ }, { }, { clear_all_filter }] = useObjCommonFilterStore();

  const [user, setUser] = useState({
    firstName: "",
    lastName: "",
    mobileNumber: "",
    telephoneNumber: "",
    companyName: "",
    isActive: ""
  });
  const [userValidation, setUserValidation] = useState({});

  useEffect(() => {
    async function fetchHere() {
      __set("USER_DETAIL_API_CALL");
      await get_user_detail(userId);
      setTimeout(() => {
        __remove("USER_DETAIL_API_CALL");
      }, 2000);
    }

    fetchHere();
  }, []);

  const openPopup = () => {
    clear_all_filter()
    System.popup('SponsorUserAcct', { userDetail, userId, userType })
  };

  const onEditUser = () => {
    setUser({
      firstName: userDetail?.firstName,
      lastName: userDetail?.lastName,
      mobileNumber: userDetail?.mobileNumber ? userDetail?.mobileNumber : "",
      telephoneNumber: userDetail?.telephoneNumber
        ? userDetail?.telephoneNumber
        : "",
      userId: userDetail?.id,
      companyName: userDetail?.companyName ? userDetail?.companyName : "",
      isActive: userDetail?.active
    });
    setUserValidation({});
    setIsEdit(true);
  };

  const onSubmit = async () => {
    const validationModal = {};

    Helper.valueIsNotNull(user.firstName) ? (user.firstName?.length < 2 ? validationModal.firstName = t('firstNameMustNotBeLessThan2Char'): '') : (validationModal.firstName = t('enterFirstName'));
    Helper.valueIsNotNull(user.lastName) ? (user.lastName?.length < 2 ? validationModal.lastName = t('lastNameMustNotBeLessThan2Char') : '') : (validationModal.lastName = t('enterLastName'));

    setUserValidation(validationModal);
    const isValid = Object.keys(validationModal).length <= 0;

    if (System.validateDomain(userDetail?.emailAddress)) {
      __set("USER_DETAIL_API_CALL");
      const data = {
        isActive: user.isActive,
        id: userId
      }
      setIsEdit(false);
      await update_user_active_status(data)
      await get_user_detail(userId);
      __remove("USER_DETAIL_API_CALL");
    } else {
      if (isValid) {
        __set("USER_DETAIL_API_CALL");
        setIsEdit(false);
        await update_user_detail(user);
        await get_user_detail(userId);
        __remove("USER_DETAIL_API_CALL");
      }
    }
  };

  const onValueChange = (field, value) => {
    if (userValidation && Object.keys(userValidation).length > 0) {
      delete userValidation[field];
    }
    setUser({ ...user, [field]: value });
  };

  return (
    <>
      {__check(["USER_DETAIL_API_CALL", "USER_ACCOUNT_API_CALL"]).status ? <AxiosIndicatorRunTimeLoader /> : (
        <div className="userdetails bg-gray3 mt-4">
          <div className="container">
            <div className="user-details-top">
              <div className="user-details-tleft">
                <div className="user-details-name  mb-3">
                  {isEdit && !System.validateDomain(userDetail?.emailAddress) ? (
                    <>
                      <div className="d-flex align-items-center user-contact">
                        <div className="me-3">
                          <label>{t('firstName')}</label>
                          <input
                            className="ps-2 form-control form-control-sm w200 mb-0"
                            placeholder={t('firstName')}
                            type="text"
                            value={user.firstName}
                            onChange={({ target: { value } }) =>
                              onValueChange("firstName", value)
                            }
                          />
                          {userValidation.firstName && (
                            <p className="error"> {userValidation.firstName}</p>
                          )}
                        </div>
                        <div>
                          <label>{t('lastName')}</label>
                          <input
                            className="ps-2 form-control form-control-sm w200 mb-0"
                            placeholder={t('lastName')}
                            type="text"
                            value={user.lastName}
                            onChange={({ target: { value } }) =>
                              onValueChange("lastName", value)
                            }
                          />
                          {userValidation.lastName && (
                            <p className="error"> {userValidation.lastName}</p>
                          )}
                        </div>
                      </div>
                    </>
                  ) : (
                    <h4 className="mt-0">
                      {userDetail?.firstName} {userDetail?.lastName}{" "}
                    </h4>
                  )}
                </div>

                <p className="text-black-stone d-flex align-items-center">
                  <span>
                    {t('updatedOn')}:{" "}
                    {userDetail?.updatedDate ? Helper.getDatepickerFormatAdminConsole(userDetail?.updatedDate) : ""}{" "}
                  </span>
                  <span className="px-2"> | </span>{" "}
                  <span className="pe-2 d-flex align-items-center">
                    {t('status')}:&nbsp;
                    {isEdit ? (
                      <label className="switch">
                        <input
                          type="checkbox"
                          checked={user.isActive}
                          onClick={(e) =>
                            onValueChange("isActive", e.target.checked)
                          }
                        />
                        <span className="slider round"></span>
                      </label>
                    ) : (
                      userDetail?.active ? t('active') : t('inactive')
                    )}
                  </span>
                </p>
              </div>
              <div className="user-details-tright">
                {isEdit ? (
                  <>
                    <div className="mb-3">
                      <button
                        className="bs5 btn btn-secondary me-3"
                        onClick={() => setIsEdit(false)}
                      >
                        {t('cancel')}
                      </button>
                      <button
                        className="bs5 btn btn-primary w200 "
                        onClick={() => {
                          onSubmit();
                        }}
                      >
                        Save
                      </button>
                    </div>
                  </>
                ) : (
                  <>
                    {!(userDetail?.source === "SAP") && (
                      <div className="mb-3">
                        <button
                          className="bs5 btn btn-secondary w200"
                          onClick={() => onEditUser()}
                        >
                          {t('edit')}
                        </button>
                      </div>
                    )}
                    {System.getCurrentRegionWithType(Constants.speedBoats.apacAbbr) && <div>
                      <button
                        className="bs5 btn btn-secondary w200"
                        onClick={() => openPopup()}
                        disabled={userDetail?.source === "SAP"}
                      >
                        {t('sponserToAnAccount')}
                      </button>
                    </div>}
                  </>
                )}
              </div>
            </div>
          </div>
          <div className="user-details-bottom">
            <ul>
              <li>
                <div className="container">
                  <div className="user-details-bottom-left">
                    <i>
                      <img src={userphone} className="me-2" />
                    </i>
                    {isEdit &&
                      !System.validateDomain(userDetail?.emailAddress) ? (
                      <div className="d-flex align-items-center user-contact">
                        <div className="me-3">
                          <label>{t('mobile')}</label>
                          <input
                            className="ps-2 form-control form-control-sm w200 mb-0"
                            placeholder={t('mobile')}
                            type="text"
                            value={user.mobileNumber}
                            onChange={({ target: { value } }) =>
                              onValueChange("mobileNumber", value)
                            }
                          />
                        </div>
                        <div>
                          <label>{t('telephone')}</label>
                          <input
                            className="ps-2 form-control form-control-sm w200 mb-0"
                            placeholder={t('telephone')}
                            type="text"
                            value={user.telephoneNumber}
                            onChange={({ target: { value } }) =>
                              onValueChange("telephoneNumber", value)
                            }
                          />
                        </div>
                      </div>
                    ) : (
                      <div className="d-flex align-items-center">
                        <p className="mb-0 text-black-stone">
                          {" "}
                          M: {userDetail?.mobileNumber}
                        </p>{" "}
                        <span className="px-3"> |</span>
                        <p className="mb-0 text-black-stone">
                          {" "}
                          T: {userDetail?.telephoneNumber}
                        </p>
                      </div>
                    )}
                  </div>
                  <div className="text-black-stone user-details-bottom-right">
                    <i>
                      <img src={useremail} className="me-2" />
                    </i>{" "}
                    <p className="mb-0 text-black-stone">
                      {" "}
                      {userDetail?.emailAddress}
                    </p>
                  </div>
                </div>
              </li>
              <li>
                <div className="container">
                  <div className="text-black-stone user-details-bottom-left">
                    <i>
                      <img src={usersource} className="me-2" />
                    </i>{" "}
                    <p className="mb-0 text-black-stone">
                      {" "}
                      {t('source')}: {userDetail?.source}
                    </p>
                  </div>
                  <div className="text-black-stone user-details-bottom-right">
                    <i>
                      <img src={usercreated} className="me-2" />
                    </i>{" "}
                    <p className="mb-0 text-black-stone">
                      {t('createdOn')}:{" "}
                      {userDetail?.createDate
                        ? Helper.getDatepickerFormatAdminConsole(userDetail?.createDate)
                        : ""}{" "}
                    </p>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      )}
    </>
  );
};

export default UserDetailHeader;
